import type {SelectOption} from "@/components";
import {bankLists} from "@/config/banksList";

interface LegacyBank {
  bank_code: string;
  bank_name: string;
  icon?: string;
}

export const BANK_OPTIONS: ReadonlyArray<SelectOption<string>> = (bankLists as LegacyBank[])
  .map(bank => ({
    value: bank.bank_code,
    label: `${bank.bank_code} · ${bank.bank_name}`,
  }))
  .sort((a, b) => a.label.localeCompare(b.label));
